<template>
  <div>
    <div class="seminar border border-info rounded p-2">
      <div class="checkSeminar d-flex justify-content-between align-items-baseline mb-2">
        <b-row>
          <b-col class="sm-12">
            <div class="d-flex">
              <b-form-checkbox class="ml-2" v-model="seminar.checkSeminar">
                <p class="btn p-0 m-0 text-info">Seminar With CO Mapping</p>
              </b-form-checkbox>
            </div>
          </b-col>
        </b-row>

        <b-row>
          <b-col class="sm-6">
            <div v-if="seminar.checkSeminar">
              <label for="seminarScore">Score:</label>
              <b-form-input
                id="seminarScore"
                v-model="seminar.seminarScore"
                placeholder="Enter Score"
                :class="{ 'form-group-error': $v.seminar.seminarScore.$error }"
              ></b-form-input>
              <span
                class="input-error-message"
                v-if="!$v.seminar.seminarScore.required && $v.seminar.seminarScore.$dirty"
              >
                Score is mandatory!
              </span>
            </div>
          </b-col>
        </b-row>
      </div>

      <b-collapse id="seminarConfig" v-model="seminar.checkSeminar" class="mt-2">
        <div class="selectSeminarType mb-2">
          <span class="text-dark font-weight-bolder">Choose Seminar Methods:</span>
        </div>

        <table class="table table-bordered table-striped">
          <thead class="thead-dark">
            <tr>
              <th></th>
              <th>Seminar Method</th>
              <th v-if="!activity_simple_calculation">Percent Weightage</th>
            </tr>
          </thead>

          <tbody>
            <tr v-if="seminarMethods.length === 0">
              <td colspan="100" class="text-danger text-center align-middle">
                No Seminar Methods Found!
              </td>
            </tr>

            <tr v-for="(method, index) in seminarMethods" :key="index">
              <td class="align-middle">
                <b-form-checkbox
                  size="sm"
                  v-model="seminarConfigStructure[method.id].checkbox"
                ></b-form-checkbox>
              </td>

              <td class="align-middle">{{ method.name }}</td>

              <td
                v-if="!activity_simple_calculation"
                class="text-center align-middle"
              >
                <b-form-input
                  v-if="seminarConfigStructure[method.id].checkbox"
                  placeholder="Enter Percentage"
                  v-model="seminarConfigStructure[method.id].input"
                  @blur="$v.seminarConfigStructure.$each.$touch()"
                ></b-form-input>

                <div
                  v-if="
                    seminarConfigStructure[method.id].checkbox &&
                    $v.seminarConfigStructure.$each[method.id].input.$error
                  "
                  class="text-danger"
                >
                  <span
                    v-if="!$v.seminarConfigStructure.$each[method.id].input.required"
                  >
                    This field is required.
                  </span>
                  <span
                    v-if="!$v.seminarConfigStructure.$each[method.id].input.numeric"
                  >
                    Value must be numeric.
                  </span>
                  <span
                    v-if="!$v.seminarConfigStructure.$each[method.id].input.customValidation"
                  >
                    All inputs must either be the same or sum up to 100.
                  </span>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </b-collapse>
    </div>
  </div>
</template>

<script>
import { requiredIf, numeric } from "vuelidate/lib/validators";
import axios from "axios";

export default {
  props: ["saved_configs", "courseReport", "activity_simple_calculation"],

  async created() {
    await this.fetchSeminarMethods();

    let savedSeminarConfig = this.saved_configs.seminar_with_co_configs;
    if (savedSeminarConfig.enable) {
      this.seminar = {
        checkSeminar: savedSeminarConfig.enable,
        seminarScore: savedSeminarConfig.score,
      };

      let selectedMethods = savedSeminarConfig.resourses.method;
      for (const key in selectedMethods) {
        if (key in this.seminarConfigStructure) {
          this.seminarConfigStructure[key].checkbox = true;
          this.seminarConfigStructure[key].input =
            selectedMethods[key].persantage_of_wightage;
        }
      }
    }
    this.seminar.checkSeminar = savedSeminarConfig.enable;
  },

  data() {
    return {
      seminar: {
        checkSeminar: false,
        seminarScore: 20,
      },
      seminarMethods: [],
      seminarConfigStructure: {},
    };
  },

  validations: {
    seminar: {
      seminarScore: {
        required: requiredIf(function () {
          return this.seminar.checkSeminar;
        }),
      },
    },
    seminarConfigStructure: {
      $each: {
        input: {
          required(value, parentVm) {
            return parentVm.checkbox;
          },
          numeric,
          customValidation() {
            if (
              !this.seminar ||
              this.seminar.checkSeminar === false ||
              this.activity_simple_calculation
            )
              return true;

            const checked = Object.values(this.seminarConfigStructure).filter(
              (c) => c.checkbox
            );
            if (checked.length === 0) return true;

            const values = checked
              .map((c) => Number(c.input))
              .filter((v) => !isNaN(v));

            if (values.length === 0) return true;

            const allSame = values.every((v) => v === values[0]);
            const sumIs100 = values.reduce((a, b) => a + b, 0) === 100;

            return allSame || sumIs100;
          },
        },
      },
    },
  },

  methods: {
    async fetchSeminarMethods() {
      const url = `${this.$store.getters.getAPIKey.mainAPI}/seminarmethods?course_id=${this.courseReport.course_id}`;
      try {
        const response = await axios.get(url);
        this.seminarMethods = response.data;
        this.seminarMethods.forEach((method) => {
          this.$set(this.seminarConfigStructure, method.id, {
            checkbox: false,
            input: "",
          });
        });
      } catch (error) {
        this.$toast.error("Failed to fetch seminar methods", {
          position: "top",
          duration: 3000,
        });
      }
    },
  },
};
</script>

<style>
.seminar p {
  font-size: 16px;
  font-weight: 600;
}
.seminar span {
  font-size: 12px;
  font-weight: 600;
}
</style>
